var infSelectorItems = [
	["58000", "FIS AM DISPENSER (5.1, 10.1, 12.2, 13.2 Oz)", 150, 5.1, "Single", "NA", "Manual"],
	["58000", "FIS AM DISPENSER (5.1, 10.1, 12.2, 13.2 Oz)", 300, 10.1, "Single", "FIS V 300 T/ FIS V Zero 300 T", "Manual"],
	["58000", "FIS AM DISPENSER (5.1, 10.1, 12.2, 13.2 Oz)", 360, 12.2, "Dual", "FIS V 360/ FIS V Zero 360", "Manual"],
	["58000", "FIS AM DISPENSER (5.1, 10.1, 12.2, 13.2 Oz)", 390, 13.2, "Dual", "FIS EM Plus 390/ FIS SB 390", "Manual"],
	//["FIS UD-1", "FIS Dual Cartridge Dispenser (fits all cartridges 5.1, 10.1, 13.2 and 19.8 fl. oz)", 360, 12.2, "Dual", "FIS V 360/ FIS V Zero 360", "Manual"],
	["FIS UD-1", "FIS Dual Cartridge Dispenser (fits all cartridges 5.1, 10.1, 13.2 and 19.8 fl. oz)", 150, 5.1, "Dual", "", "Manual"],
	["FIS UD-1", "FIS Dual Cartridge Dispenser (fits all cartridges 5.1, 10.1, 13.2 and 19.8 fl. oz)", 300, 10.1, "Dual", "FIS V 300 T/ FIS V Zero 300 T", "Manual"],
	["FIS UD-1", "FIS Dual Cartridge Dispenser (fits all cartridges 5.1, 10.1, 13.2 and 19.8 fl. oz)", 390, 13.2, "Dual", "FIS EM Plus 390/ FIS SB 390", "Manual"],
	["FIS UD-1", "FIS Dual Cartridge Dispenser (fits all cartridges 5.1, 10.1, 13.2 and 19.8 fl. oz)", 585, 19.8, "Dual", "FIS EM Plus 585", "Manual"],
	["563337", "FIS DM S - Pro (5.1, 10.1, 12.2, 13.2 Oz)", 150, 5.1, "Dual", "NA", "Manual"],
	["563337", "FIS DM S - Pro (5.1, 10.1, 12.2, 13.2 Oz)", 300, 10.1, "Dual", "NA", "Manual"],
	["563337", "FIS DM S - Pro (5.1, 10.1, 12.2, 13.2 Oz)", 360, 12.2, "Dual", "FIS V 360/ FIS V Zero 360", "Manual"],
	["563337", "FIS DM S - Pro (5.1, 10.1, 12.2, 13.2 Oz)", 390, 13.2, "Dual", "FIS EM Plus 390/ FIS SB 390", "Manual"],
	["511125", "FIS DP S-L - Pneumatic Dispenser (19.8 oz. cartridges only)", 585, 19.8, "Dual", "FIS EM Plus 585", "Pneumatic"],
	["58027", "FIS AP - PNEUMATIC DISPENSER (Fits all 12.2 & 13.2 0z, dual cartridges only)", 360, 12.2, "Dual", "FIS V 360/ FIS V Zero 360", "Pneumatic"],
	["58027", "FIS AP - PNEUMATIC DISPENSER (Fits all 12.2 & 13.2 0z, dual cartridges only)", 390, 13.2, "Dual", "FIS EM Plus 390/ FIS SB 390", "Pneumatic"],
	["53117", "KPM 2 Plus DISPENSER (10.1 0z, single cartridge only)", 300, 10.1, "Single", "FIS V 300 T/ FIS V Zero 300 T", "Manual"],
	["558955", "FIS DB S Pro Battery Dispenser (300, 360 and 390 ml i.e. 10.1, 12.2 and 13.2 Oz.)", 300, 10.1, "Single", "FIS V 300 T/ FIS V Zero 300 T", "Battery Operated"],
	["558955", "FIS DB S Pro Battery Dispenser (300, 360 and 390 ml i.e. 10.1, 12.2 and 13.2 Oz.)", 360, 12.2, "Dual", "FIS V 360/ FIS V Zero 360", "Battery Operated"],
	["558955", "FIS DB S Pro Battery Dispenser (300, 360 and 390 ml i.e. 10.1, 12.2 and 13.2 Oz.)", 390, 13.2, "Dual", "FIS EM Plus 390/ FIS SB 390", "Battery Operated"],
	["562004", "FIS DB SL Pro Battery Dispenser 585 ml and 825 ml (19.8 Oz. and 27.9 Oz)", 585, 19.8, "Dual", "FIS EM Plus 585", "Battery Operated"],
	["562004", "FIS DB SL Pro Battery Dispenser 585 ml and 825 ml (19.8 Oz. and 27.9 Oz)", 825, 27.9, "Dual", "NA", "Battery Operated"],
	["567295", "FIS DB SL Pro Solo Battery dispenser (585 ml and 825 ml i.e. 19.8 Oz. and 27.9 Oz) without battery", 825, 19.8, "Dual", "FIS EM Plus 585", "Battery Operated"],
	["567295", "FIS DB SL Pro Solo Battery dispenser (585 ml and 825 ml i.e. 19.8 Oz. and 27.9 Oz) without battery", 825, 27.9, "Dual", "NA", "Battery Operated"]
];



var infSelector = {

  popOverVisible: false,

    formClose: '<button id="infSelectorclose" type="button" class="infSelectorclose-toggle" aria-label="Close"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L19.5303 5.53033ZM4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L4.46967 18.4697ZM5.53034 4.46967C5.23745 4.17678 4.76258 4.17678 4.46968 4.46967C4.17679 4.76256 4.17679 5.23744 4.46968 5.53033L5.53034 4.46967ZM18.4697 19.5303C18.7626 19.8232 19.2375 19.8232 19.5304 19.5303C19.8232 19.2374 19.8232 18.7626 19.5304 18.4697L18.4697 19.5303ZM18.4697 4.46967L4.46967 18.4697L5.53033 19.5303L19.5303 5.53033L18.4697 4.46967ZM4.46968 5.53033L18.4697 19.5303L19.5304 18.4697L5.53034 4.46967L4.46968 5.53033Z" fill="#001A72"></path></svg></button>',
    formContent: "<p><select id=\"volumeselector\"><option value=\"\">Choose volume</option></select></p>\n<table style=\"width:100%\">\n\t<thead>\n\t\t<tr>\n\t\t\t<th>Item number</th>\n\t\t\t<th>Product description</th>\n\t\t\t<th>Volume ml</th>\n\t\t\t<th>Volume Oz</th>\n\t\t\t<th>Type of cartridge</th>\n\t\t\t<th>Chemicals can be dispensed</th>\n\t\t\t<th>Type of dispenser</th>\n\t\t</tr><tr>\n\t</tr></thead>\n\t<tbody id=\"itembody\">\n\t\t\n\t</tbody>\n\t</table>\n\n\t\n\n",

  preparePopOver: function() {
      var div = document.createElement("div");
    div.id = 'infSelector_popover';
    div.style.display = 'none';
    div.role = 'dialog';
    div.ariaModal = 'true';
    div.ariaLabel = 'fischer Anchors Selector';
    div.tabindex = '-1';

    div.innerHTML = '<div id="infSelector_overlay" class="infSelector_overlay"></div><div id="infSelector_content" class="infSelector_content"></div>';

    document.body.appendChild(div);
    var calculatorDialog = document.getElementById('infSelector_content');
    calculatorDialog.innerHTML = infSelector.formClose + infSelector.formContent;
    // handle close
    document.getElementById('infSelector_overlay').addEventListener('click', infSelector.handleOverlayClick);
    document.getElementById('infSelectorclose').addEventListener('click', infSelector.handleOverlayClick);
    document.addEventListener('keydown', infSelector.keyDownHandler);



    // handle open
    var allx = document.querySelectorAll('[data-inf-toggle="selector"]')
    for(var n = 0; n < allx.length; n++) {
        allx[n].addEventListener('click', function(ev) {
          ev.preventDefault();
        infSelector.showPopOver();
        });
    }
    infSelector.calc();
  },

  calc: function() {
    var ib = document.getElementById("itembody");
    const volumeSet = new Set();
    var volumeselector = document.getElementById("volumeselector");
    
    for (var n = 0; n < infSelectorItems.length; n++)
    {
    	volumeSet.add(infSelectorItems[n][3]);
    	var row = document.createElement("tr");
    	row.dataset.volumeOz = infSelectorItems[n][3];
    	row.dataset.volumeMl = infSelectorItems[n][2];
    	for(var i = 0; i < infSelectorItems[n].length; i++)
    	{
    		var cell = document.createElement("td");
    		cell.textContent = infSelectorItems[n][i];
    		row.append(cell);
    	}
    	ib.append(row);
    }
    var volumeArray = Array.from(volumeSet);
    for (var n = 0; n < volumeArray.length; n++)
    {
    	var option = document.createElement("option");
    	option.textContent = volumeArray[n] + " Oz";
    	option.value = volumeArray[n];
    	volumeselector.append(option);
    }
    volumeselector.addEventListener('change', infSelector.setFilter);

  },
  setFilter: function(el) {
	var ib = document.getElementById("itembody");
	var allRows = document.querySelectorAll("tr");
	for(var n = 0; n < allRows.length; n++)
	{
		allRows[n].classList.remove("highlight");
	}
	var showRows = document.querySelectorAll("tr[data-volume-oz=\"" + el.target.value + "\"]");
	for(var n = 0; n < showRows.length; n++)
	{
		showRows[n].classList.add("highlight");
	}

  },

  showPopOver: function() {
   // console.log(document.documentElement.scrollTop);
    if (infSelector.popOverVisible == false)
    {
      infSelector.popOverVisible = true;
      document.body.style.overflow = "hidden";
      document.getElementById('infSelector_popover').style.top = document.documentElement.scrollTop + "px";
      document.getElementById('infSelector_popover').style.display = "block";
    }
    
  },
  hidePopOver: function() {
    if (infSelector.popOverVisible == true)
    {
      infSelector.popOverVisible = false;
      document.body.style.overflow = null;
      document.getElementById('infSelector_popover').style.display = "none";
    }
  },
  keyDownHandler: function(ev) {
    if(ev.key == 'Escape')
      infSelector.hidePopOver();
  },
  handleOverlayClick: function(ev) {
    infSelector.hidePopOver();
  }


};
infSelector.preparePopOver();